__turbopack_context__.v({
  "accept": "style-module-scss-module__VvNWMW__accept",
  "banner": "style-module-scss-module__VvNWMW__banner",
  "bannerWrapper": "style-module-scss-module__VvNWMW__bannerWrapper",
  "buttons": "style-module-scss-module__VvNWMW__buttons",
  "content": "style-module-scss-module__VvNWMW__content",
  "decline": "style-module-scss-module__VvNWMW__decline",
  "heading": "style-module-scss-module__VvNWMW__heading",
});
